<div class="backTOAct notprintable" *ngIf="isFromActivity"><a (click)="navigateToActivityPage()"> <span nz-icon
            nzType="left" nzTheme="outline"></span> Back to Activity</a></div>
<div [ngClass]="isFromActivity ? 'summaryWidth': ''">
    <div class="d-flex justify-content-space-between p-2 align-i-c">
        <div style="display: flex;align-items: center;width: 100%;">
            <h1 class="fs-35">Transaction Details</h1>
            <span *ngIf="currentTransactionDetails && currentTransactionDetails.underReviewInfo?.isMarkedAsUnderReview"
                class="under-review-badge ml-1"
                [ngStyle]="{'background-color':currentTransactionDetails.underReviewInfo?.color}">Under Review</span>
            <span *ngIf="currentTransactionDetails && currentTransactionDetails.underReviewInfo?.isMarkedAsUnderReview"
                class="fs-20 ml-1 ellipsis-text" style="width: 50%;font-weight: bold;"
                [ngStyle]="{'color':currentTransactionDetails.underReviewInfo?.color}">{{currentTransactionDetails.underReviewInfo?.reason}}</span>
        </div>
        <button class="notPrintable" nz-button nzType="primary" (click)="printTransaction()"
            [disabled]="enableDropdowns || !currentTransactionDetails"><span nz-icon nzType="printer"
                nzTheme="outline"></span>Print</button>
    </div>
    <!-- *ngIf="isFromActivity" -->
    <hr />
    <nz-skeleton *ngIf="this.isFetchingDetails" [nzParagraph]="{rows: 5}" [nzActive]="true"></nz-skeleton>
    <h2 *ngIf="!this.isFetchingDetails && !currentTransactionDetails" class="center">No Record Found</h2>

    <!--transaction is investment or payment-->
    <!-- {{currentTransactionDetails | json}} {{transactionType}} {{transactionTypeEnum.Investment}} -->
    <div class="p-2 transaction-details-box"
        *ngIf="currentTransactionDetails && (transactionType == transactionTypeEnum.Investment || transactionType == transactionTypeEnum.Refunds)">
        <div class="d-flex justify-content-space-between">
            <div>
                <div class="d-flex">
                    <h1 class="investment-title pb-1">{{'Investment'}}{{transactionType ==
                        transactionTypeEnum.Refunds ? ' Refund' : ''}}</h1>

                    <!-- <span
                        *ngIf="currentTransactionDetails && transactionType == transactionTypeEnum.Investment && currentTransactionDetails.paybevInvestmentStatus ==  6 ? 'Under Review' : ''"
                        class="under-review-badge ml-1">Under Review</span> -->
                </div>
                <div class="d-flex date-transaction-text align-i-c">
                    <p *ngIf="transactionType == transactionTypeEnum.Investment">{{
                        ((currentTransactionDetails.brooklynInvestmentStatus > 1 &&
                        currentTransactionDetails.brooklynInvestmentStatus <= 6) ||
                            currentTransactionDetails.brooklynInvestmentStatus==8) ?
                            ((currentTransactionDetails.investmentDetails.quickBookInvestment.qboEntityDate).slice(0,-1)
                            | date: 'MMMM dd, yyyy' ) : currentTransactionDetails.brooklynInvestmentStatus==10 ?
                            (currentTransactionDetails?.investmentDetails?.quickBookInvestment?.qboEntityVoidDate?.slice(0,-1)
                            | date: 'MMMM dd, yyyy' ) : currentTransactionDetails.brooklynInvestmentStatus==1 ?
                            (currentTransactionDetails.createdOn | date: 'MMMM dd, yyyy' ) :
                            currentTransactionDetails.investmentDetails.quickBookInvestment.qboEntityPaidDate.slice(0,-1)
                            | date: 'MMMM dd, yyyy' }}</p>

                            <p *ngIf="transactionType == transactionTypeEnum.Refunds">{{
                                currentTransactionDetails.refundsDetails.qboEntityDate.slice(0,-1) | date: 'MMMM dd, \
                                yyyy' }}</p>

                            <nz-tag class="bg-theme investment-tag"
                                [ngClass]="currentTransactionDetails?.brooklynBillStatus ==  brooklynBillStatus.UnderReview || currentTransactionDetails?.brooklynInvestmentStatus ==  2 || currentTransactionDetails?.status == 'Voided' ? 'bg-red':''">{{currentTransactionDetails?.status}}</nz-tag>
                            <!-- <p class="transaction-text" *ngIf="currentTransactionDetails.transactionsNo"><b>Transaction
                                    No:
                                </b>{{currentTransactionDetails.transactionsNo}}</p> -->

                            <p class="pl-1 estimated-text"
                                *ngIf="showCancelButton && currentTransactionDetails.estimatedArrivalDate && transactionType == transactionTypeEnum.Investment && currentTransactionDetails?.investmentDetails?.paybevInvestment?.class != null">
                                <b>Estimated Arrival Date</b>
                                {{currentTransactionDetails.estimatedArrivalDate ?
                                (currentTransactionDetails.estimatedArrivalDate.toString().includes('0001'))
                                ? '-'
                                : ((currentTransactionDetails.estimatedArrivalDate) | date : 'MM/dd/yyyy' ): '-' }}
                            </p>
                </div>
            </div>
            <!-- <div *ngIf="!isFromActivity">
                <button class="notPrintable" nz-button nzType="primary" (click)="printTransaction()"
                    [disabled]="enableDropdowns || !currentTransactionDetails"><span nz-icon nzType="printer"
                        nzTheme="outline"></span>Print</button>
            </div> -->
        </div>
        <p class="client-name-time-text notPrintable">Submitted {{currentTransactionDetails.createdBy ? 'by ' +
            currentTransactionDetails.createdBy : ''}}
            on {{currentTransactionDetails.createdOn | date : 'MMMM d, yyyy'}} at
            {{currentTransactionDetails.createdOn | date : 'shortTime'}}</p>
        <div nz-row class="section-top-padding">
            <div class="print-left-box" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                <div class="mb-1">
                    <div class="investment-label-text">{{'Company'}}:</div>
                    <span class="investment-company-name">
                        <div *ngIf="transactionType == transactionTypeEnum.Investment" class="pl-2">
                            {{currentTransactionDetails.siteName ? currentTransactionDetails.siteName : '-'}}
                        </div>
                        <div *ngIf="transactionType == transactionTypeEnum.Refunds" class="pl-2">
                            {{currentTransactionDetails.quickBookCustomerDetails.siteName ?
                            currentTransactionDetails.quickBookCustomerDetails.siteName : '-'}}
                        </div>
                    </span>
                </div>

                <div class="mb-1"
                    *ngIf="transactionType == transactionTypeEnum.Investment || transactionType == transactionTypeEnum.Refunds">
                    <div class="investment-label-text">Representative:</div>
                    <div class="d-flex">
                        <span class="investment-company-name d-flex justify-content-space-between pl-2 pr-7">
                            <p>{{currentTransactionDetails.repName }}</p>
                        </span>
                        <!-- class="mr-8" -->
                        <p
                            *ngIf="transactionType == transactionTypeEnum.Investment && currentTransactionDetails.customerDetails.quickBookCustomerDetails?.email">
                            {{currentTransactionDetails.customerDetails.quickBookCustomerDetails?.email}}</p>
                        <p *ngIf="transactionType == transactionTypeEnum.Refunds">
                            {{currentTransactionDetails.quickBookCustomerDetails?.email}}</p>
                    </div>
                </div>

                <div class="mb-1" *ngIf="showInvoiceNumber">
                    <div class="investment-label-text">{{transactionType == transactionTypeEnum.Refunds ||
                        transactionType == transactionTypeEnum.Credits || transactionType ==
                        transactionTypeEnum.Deposits ? 'Ref Number' : 'Invoice Number'}}:</div>
                    <span class="investment-company-name pl-2"
                        *ngIf="transactionType != transactionTypeEnum.Deposits">{{transactionType == 2 ?
                        (currentTransactionDetails.brooklynBillStatus == brooklynBillStatus.PendingApproval ?
                        currentTransactionDetails.billDetails.paybevPayment.billNo :
                        currentTransactionDetails.qboEntityNo) : (currentTransactionDetails.qboEntityNo ?
                        currentTransactionDetails.qboEntityNo : '-')}}</span>
                    <span class="investment-company-name pl-2"
                        *ngIf="transactionType == transactionTypeEnum.Deposits">{{currentTransactionDetails.depositCheckNum
                        ?
                        currentTransactionDetails.depositCheckNum : '-'}}</span>
                </div>
                <div class="mb-1">
                    <div class="investment-label-text">Description:</div>
                    <div *ngIf="(transactionType == transactionTypeEnum.Investment)">
                        <div *ngIf="currentTransactionDetails.investmentDetails.quickBookInvestment">
                            <span class="investment-company-name pl-2"
                                *ngIf="!currentTransactionDetails.investmentDetails.quickBookInvestment.description">-</span>
                            <div *ngIf="currentTransactionDetails.investmentDetails.quickBookInvestment.description"
                                class="investment-company-name pb-0" style="white-space:pre-wrap"
                                [innerHTML]="currentTransactionDetails.investmentDetails.quickBookInvestment.description">
                            </div>
                            <br>
                        </div>
                        <div *ngIf="!currentTransactionDetails.investmentDetails.quickBookInvestment">
                            <span class="investment-company-name pl-2"
                                *ngIf="!currentTransactionDetails.description">-</span>
                            <div *ngIf="currentTransactionDetails.description" class="investment-company-name pb-0"
                                style="white-space:pre-wrap" [innerHTML]="currentTransactionDetails.description">
                            </div>
                            <br>
                        </div>
                    </div>
                    <div *ngIf="!(transactionType == transactionTypeEnum.Investment)">
                        <span class="investment-company-name pl-2"
                            *ngIf="!currentTransactionDetails.description">-</span>
                        <div *ngIf="currentTransactionDetails.description" class="investment-company-name pb-0"
                            style="white-space:pre-wrap" [innerHTML]="currentTransactionDetails.description">
                        </div>
                        <br>
                    </div>
                </div>
            </div>
            <div class="print-right-box" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                <div class="mb-1">
                    <p class="investment-company-name investment-title text-right"><label>Invoice Amount:</label></p>
                    <p class="gross-amount-total text-right">{{currentTransactionDetails.amount | currency}}</p>
                </div>
                <!-- <div class="d-flex align-i-c mb-1 justify-content-space-between padding pb-0">
                    <p class="investment-label-text">{{transactionType == transactionTypeEnum.Refunds ? '' :
                        transactionType == transactionTypeEnum.Credits ? 'Credit' : transactionType ==
                        transactionTypeEnum.Deposits ? 'Deposit' : 'Invoice'}} Amount: </p>
                    <p class="investment-company-name pb-0">{{currentTransactionDetails.amount | currency}}</p>
                </div> -->
                <div class="d-flex align-i-c mb-1 justify-content-space-between padding pb-0"
                    *ngIf="currentTransactionDetails.serviceFee || currentTransactionDetails.processingFee">
                    <p class="investment-label-text">{{'Process Fee'}}: </p>
                    <p class="investment-company-name pb-0">{{
                        '-'+(currentTransactionDetails.processingFee | currency)}}</p>
                </div>
                <!-- <div class="d-flex align-i-c mb-1 justify-content-space-between net-to-program-box">
                    <p class="investment-label-text">Net To Program: </p>
                    <p class="investment-company-name pb-0"
                        *ngIf="!(transactionType == transactionTypeEnum.Credits || transactionType == transactionTypeEnum.Deposits)">
                        {{transactionType == transactionTypeEnum.Payment ? '\
                        '+(((currentTransactionDetails.amount + currentTransactionDetails.serviceFee)* -1) | currency) :
                        (transactionType == transactionTypeEnum.Refunds ? '-' : '+')
                        +((currentTransactionDetails.amount -
                        parseStringToNumber(currentTransactionDetails.processFee)) | currency) }}</p>
                    <p class="investment-company-name pb-0"
                        *ngIf="transactionType == transactionTypeEnum.Credits || transactionType == transactionTypeEnum.Deposits">
                        +{{currentTransactionDetails.amount | currency}}</p>
                </div> -->
                <div class="d-flex align-i-c mb-1 justify-content-space-between net-to-program-box bg-light"
                    *ngIf="(currentTransactionDetails.isNonAlc == true || currentTransactionDetails.isNonALC== true) && siteDetails?.NonAlcStatus">
                    <div class="d-flex">
                        <span class="RoundBox"
                            [ngClass]="currentTransactionDetails.isNonAlc || currentTransactionDetails.isNonALC ? 'nonAlcRoundColor' : ''"></span>

                        <p class="investment-label-text">Non-alc Credit: </p>
                    </div>
                    <p class="investment-company-name pb-0"><span>{{
                            transactionType == transactionTypeEnum.Refund ?
                            '- ' : '+ '}}</span>{{currentTransactionDetails.amount | number}}</p>
                </div>
                <!-- <ng-container *ngTemplateOutlet="ProgramTagTemplate"></ng-container>
                <ng-container *ngTemplateOutlet="printProgramTagTemp"></ng-container> -->
            </div>
        </div>
    </div>
    <!-- program and tag dropdowns code -->
    <ng-template #ProgramTagTemplate>
        <div *ngIf="siteDetails &&
                    (
                        (siteDetails.IsProgramPeriodVisible != null ? siteDetails.IsProgramPeriodVisible : true) ||
                        (
                        (siteDetails.IsTagVisible != null ? siteDetails.IsTagVisible : true) &&
                            !(
                                transactionType == transactionTypeEnum.Investment ||
                                transactionType == transactionTypeEnum.StartingBalance ||
                                transactionType == transactionTypeEnum.Refunds
                            )
                        )
                    )">

            <div class="notPrintable">
                <div class="payment-form-box">
                    <div>
                        <span *ngIf="!enableDropdowns" class="span-text ant-btn edti-btn notPrintable"
                            (click)="manageTrDeatails()">Edit</span>
                    </div>
                    <nz-form-item
                        *ngIf="(siteDetails.IsProgramPeriodVisible != null ? siteDetails.IsProgramPeriodVisible : true)">
                        <nz-form-control>
                            <div class="d-flex align-i-c justify-content-space-between"> <label class="label-text">
                                    Program period</label><span class="span-text"
                                    [ngClass]="!enableDropdowns ? 'cl-gray' : ''"
                                    (click)="enableDropdowns ? manageProgramPeriod() : $event.preventDefault">Manage</span>
                            </div>
                            <nz-select nzShowSearch nzPlaceHolder="Select Program Period" [nzSize]="'default'"
                                (ngModelChange)="getProgramName($event)" [(ngModel)]="selectedProgram"
                                [nzDisabled]="!enableDropdowns " [nzCustomTemplate]="showCurrentTemp">
                                <ng-container *ngIf="!_cS.isLoadingTags">
                                    <nz-option *ngFor="let option of listOfPrograms" [nzLabel]="option.label"
                                        [nzValue]="option.id"></nz-option>
                                </ng-container>
                                <nz-option *ngIf="_cS.isLoadingTags" nzDisabled nzCustomContent>
                                    <span nz-icon nzType="loading" class="loading-icon"></span>
                                    Loading Data...
                                </nz-option>
                            </nz-select>
                            <ng-template #showCurrentTemp let-selected>
                                <span>{{ selected.nzLabel }}
                                    <span [ngClass]="selectedProgram == currentDefaultProgram?.id ? 'program-box' : ''">
                                        {{selectedProgram == currentDefaultProgram?.id ? 'Current Program' :
                                        ''}}</span>
                                </span>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item
                        *ngIf="!(transactionType == transactionTypeEnum.Investment || transactionType == transactionTypeEnum.StartingBalance || transactionType == transactionTypeEnum.Refunds) && (siteDetails.IsTagVisible != null ? siteDetails.IsTagVisible : true)">
                        <nz-form-control>
                            <div class="d-flex align-i-c justify-content-space-between"><label
                                    class="label-text">Tag</label>
                                <span class="span-text" [ngClass]="!enableDropdowns ? 'cl-gray' : ''"
                                    (click)="enableDropdowns ? manageTags() : $event.preventDefault">Manage</span>
                            </div>
                            <nz-select class="select-tag-box" nzShowSearch [nzDisabled]="!enableDropdowns"
                                nzPlaceHolder="Select Tag" [nzSize]="'default'" [(ngModel)]="selectedTag"
                                (ngModelChange)="checkTagGroupData($event)" [nzCustomTemplate]="defaultTemplate">
                                <ng-container *ngFor="let option of listOfTags">
                                    <ng-container *ngIf="!_cS.isLoadingTags">
                                        <nz-option-group [nzLabel]="optionGrouptemplate">
                                            <nz-option *ngFor="let tag of option.Tags" nzCustomContent
                                                [nzValue]="tag._id" [nzLabel]="tag.Name">
                                                <span class="tag-list ml-2">
                                                    <span [ngStyle]="{'background-color': option.Color }"
                                                        style="width: 10px;height:30px"></span>&nbsp;<span
                                                        class="tagGroupName">{{ option?.Name !=
                                                        'Uncategorized' ? option.Name : ''}}</span>{{option?.Name !=
                                                    'Uncategorized' ?
                                                    ':' : ''}}&nbsp;
                                                    <b>{{
                                                        tag.Name }}</b>
                                                </span>
                                            </nz-option>
                                        </nz-option-group>
                                        <ng-template #optionGrouptemplate><span class="d-flex"><span
                                                    class="rountTagGroupColor rount-tag"
                                                    [ngStyle]="{'background-color':option.Color}"></span><span
                                                    class="tag-group">{{option.Name}}</span></span></ng-template>
                                    </ng-container>
                                </ng-container>
                                <nz-option *ngIf="_cS.isLoadingTags" nzDisabled nzCustomContent>
                                    <span nz-icon nzType="loading" class="loading-icon"></span>
                                    Loading Data...
                                </nz-option>
                            </nz-select>
                            <ng-template #defaultTemplate let-selected>
                                <span class="tag-list customTagShowDD">
                                    <span [ngStyle]="{'background-color': selectedTagGroup?.Color }"
                                        style="width: 10px;height:30px"></span>&nbsp;{{ selectedTagGroup?.Name
                                    }}{{selectedTagGroup?.Name != 'Uncategorized' ? ':' : ''}}&nbsp; <b
                                        *ngIf="selectedTagGroup?.Name != 'Uncategorized'">{{
                                        selected.nzLabel }}</b>
                                </span>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                    <div class="d-flex justify-content-end notPrintable" *ngIf="enableDropdowns">
                        <button nz-button nzType="primary" class="medium-btn cancel-btn width-100 mr-1"
                            (click)="undoChanges()">Cancel</button>
                        <button nz-button nzType="primary" (click)="saveTrDetails()" [nzLoading]="isUpdatingDetails"
                            class="medium-btn small-btn width-100"
                            [disabled]="transactionType == transactionTypeEnum.Investment ? !selectedProgram : !selectedProgram && !selectedTag">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <!-- print code for programs and tags -->

    <div class="d-flex justify-content-end p-2">
        <div *ngIf="transactionType == transactionTypeEnum.Investment">
            <button nz-button nzType="default" class="default-btn width-100 notPrintable"
                *ngIf="currentTransactionDetails && currentTransactionDetails.qboInvoiceLink != null"
                (click)="openPublicInvoice(currentTransactionDetails.qboInvoiceLink)" [disabled]="enableDropdowns">View
                Invoice</button>
        </div>

        <div *ngIf="transactionType == transactionTypeEnum.Investment">
            <!-- currentTransactionDetails.brooklynInvestmentStatus == 1 ||
                currentTransactionDetails.brooklynInvestmentStatus == 7 ? 'Canceled' : -->
            <!-- [ngClass]="isCancelled ? 'cl-red' : ''" -->
            <button nz-button nzType="primary" (click)="showCancelRequestModal()"
                [disabled]="(isCancelled && currentTransactionDetails.brooklynInvestmentStatus != 1) || enableDropdowns"
                *ngIf="currentTransactionDetails && showCancelButton && canDeleteInvestmemnt"
                class="medium-btn small-btn width-100 notPrintable ml-1">{{(

                currentTransactionDetails.brooklynInvestmentStatus == 1 ? 'Delete Investment' : isCancelled ?
                'Under Review'
                : 'Cancel | Edit' +
                (transactionDetails.transactionsSubType == 1 ? ' Estimate' : ' Invoice')) }}</button>
        </div>
    </div>
</div>
<!--modal to manage program period-->
<nz-drawer [nzVisible]="showProgramDrawer" *ngIf="showProgramDrawer" (nzOnClose)="handleCancelProgram()"
    [nzTitle]="'Manage Program Periods'" [nzWidth]="850" [nzMaskClosable]="false">
    <app-manage-programs *nzDrawerContent [isInvestmentModal]="isPaymentModal"
        (newAddedProgram)="newAddedProgram($event)" (addUpdateProgram)="addUpdateProgram($event)">
    </app-manage-programs>
</nz-drawer>

<!--modal to manage tags period-->
<nz-drawer [nzVisible]="showTagsModal" *ngIf="showTagsModal" (nzOnClose)="handleCancelTags()" [nzTitle]="'Manage Tags'"
    [nzWidth]="850" [nzMaskClosable]="false">
    <app-manage-tags *nzDrawerContent (newCreatedTag)="patchTagToForm($event)"
        [isFromManageScreen]="true"></app-manage-tags>
</nz-drawer>


<nz-modal [(nzVisible)]="isVisibleDeleteModal" nzCentered [nzMaskClosable]="false" (nzOnCancel)="handleCancel()">
    <div class="confirm-modal">
        <ng-container *nzModalContent class="cc">
            <div class="close-icon center">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
            </div>
            <h4 class="confirm-modal-title center ">Are You Sure?</h4>
            <p class="confirm-modal-sub-title center ">This {{'Investment'}} will be deleted and cannot be recovered.
                Are you sure you would
                like to continue?</p>
        </ng-container>
        <div *nzModalFooter class=" d-flex justify-content-end">
            <button nz-button nzType="default" (click)="handleCancel()" class="default-btn width-100 ">Cancel</button>
            <button nz-button nzType="primary" (click)="deleteTransaction()" class=" medium-btn delete-btn width-100"
                [nzLoading]="isDeleting">Delete</button>
        </div>
    </div>
</nz-modal>

<app-cancel-transaction *ngIf="isVisibleEditCancelRequestModal" [transactionType]="transactionType"
    [transactionId]="transactionId" [currentTransactionDetails]="currentTransactionDetails"
    (hideCancelPaymentModal)="hideCancelPaymentModal($event)"></app-cancel-transaction>